module.exports = __webpack_public_path__ + "assets/nube.68369b289f85d39f7523e04c5c4fff54.svg";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/nube.svg
// module id = 875
// module chunks = 0